import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HCBoost from "highcharts/modules/boost";
import HCDataGrouping from "highcharts/modules/data";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthProvider";

// Initialize data grouping module
HCDataGrouping(Highcharts);
HCBoost(Highcharts);

const PercentageGraph = ({
  actual = [
    78, 44, 61, 96, 66, 22, 36, 38, 52, 47, 25, 54, 16, 87, 83, 34, 52, 51, 87,
  ],
  categories = [
    "Paternoster Humidity",
    "Paternoster Temp",
    "Double Spray Time",
    "Spray Count",
    "Time to Slit",
    "Time to Press Lam",
    "Slit to Spray Time",
    "Spray & Dry Time",
    "Dry Tunnel Clock Hour",
    "Dry Tunnel Month",
    "AML Glue Weight",
    "AML Water Weight",
    "AML Board Weight",
    "Vertical Roller Gap",
    "Glue Factor",
    "Air Fan Factor",
    "Air Atom Factor",
    "Quantity of glue",
    "Cure Time",
  ],
}) => {
  const [state, setState] = useState(null);
  const { QCFull } = useAuthContext();

  const timezoneOffset = new Date().getTimezoneOffset();
  useEffect(() => {
    setState({
      chart: {
        type: "column",
        zoomType: "x",
        height: QCFull
          ? window.screen.height - window.screen.height / 3
          : window.screen.height - window.screen.height / 2.1 || "450px",
      },
      title: {
        text: "Percentage of variable Breaching Design Limits",
        align: "center",
        floating: false,
        margin: 15,
        style: {
          color: "#404040",
          fontSize: "15px",
          fontWeight: "500",
          fontFamily: "Montserrat, sans-serif",
        },
        useHTML: false,
        verticalAlign: undefined,
        widthAdjust: -44,
      },
      series: [
        {
          data: actual,
          type: "column",
          name: "Variable",
          color: "#EA8600",
          lineWidth: 1,
          marker: {
            enabled: true,
            radius: 1.5,
          },
          showInLegend: true,
          turboThreshold: Infinity,
        },
      ],
      legend: {
        align: "right",
        verticalAlign: "top",
        layout: "horizontal",
        alignColumns: false,
        itemStyle: {
          fontSize: "11px",
          fontWeight: "600",
        },
      },
      tooltip: {
        valueSuffix: "",
        shared: true,
        crosshair: true,
        style: {
          fontSize: "11px",
          fontWeight: "600",
        },
      },
      boost: {
        seriesThreshold: 100000,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          dataGrouping: {
            enabled: true,
            approximation: "average", // Choose appropriate aggregation function
            groupPixelWidth: 10, // Adjust based on your data density
          },
        },
      },
      time: {
        timezoneOffset: timezoneOffset,
      },
      xAxis: {
        categories: categories,
        crosshair: {
          width: 1,
          color: "#e4e4e4",
          dashStyle: "Solid",
        },
        title: {
          text: "Variable",
        },
        labels: {
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
      yAxis: {
        max: 100,
        title: {
          text: "Percentage",
        },
        labels: {
          format: "{text}%",
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
    });
  }, [window.screen.height, QCFull, actual]);

  if (!actual) {
    return null; // or render a loading indicator
  }

  return (
    <div id="chart" style={{ borderRadius: "16px" }}>
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};
export default PercentageGraph;
